export function selectIdsToMark(unreadIds: string[] | undefined, alreadyMarked: ReadonlySet<string>): string[] {
  if (!unreadIds || unreadIds.length === 0) return [];
  return unreadIds.filter((id) => !alreadyMarked.has(id));
}
